export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37')
];

export const server_loads = [];

export const dictionary = {
		"/(app)": [5,[2]],
		"/(app)/account": [6,[2]],
		"/(app)/achievements": [7,[2]],
		"/(app)/ambassador/toolkit": [8,[2]],
		"/(app)/calculator": [9,[2]],
		"/(app)/carbon": [10,[2]],
		"/(app)/carbon/results": [11,[2]],
		"/(app)/dashboard-legacy": [12,[2]],
		"/(app)/eco-gigs": [13,[2]],
		"/(app)/emergency": [14,[2]],
		"/(auth)/forgot-password": [32,[4]],
		"/(app)/grants": [15,[2]],
		"/(app)/guilds": [16,[2]],
		"/(app)/guilds/new": [19,[2]],
		"/(app)/guilds/[slug]": [17,[2]],
		"/(app)/guilds/[slug]/edit": [18,[2]],
		"/home": [36],
		"/ignore-this-dashboard-template": [37],
		"/(app)/leaderboard": [20,[2]],
		"/(app)/learning-hub": [21,[2]],
		"/(app)/learning-hub/calc-101": [22,[2]],
		"/(app)/learning-hub/gradebook": [23,[2]],
		"/(app)/learning-hub/solar-gateway-101": [24,[2]],
		"/(auth)/login": [33,[4]],
		"/(app)/missions": [25,[2]],
		"/(app)/missions/new": [28,[2]],
		"/(app)/missions/[id]": [26,[2]],
		"/(app)/missions/[id]/edit": [27,[2]],
		"/(app)/profile": [29,[2]],
		"/(auth)/reset-password": [34,[4]],
		"/(auth)/signup": [35,[4]],
		"/(app)/tools": [30,[2]],
		"/(app)/u/[username]": [31,[2]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';